import { ConcreteEncodable } from "./ConcreteEncodable";

import { TestEntityEncoder } from "../../encoder/TestEntityEncoder";

import * as CubiqTS from "../../index";

export class TestEntity extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.model.TestEntity";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public integer: number;
  /*FID=3*/
  public integerObject: number;
  /*FID=4*/
  public bigD: CubiqTS.BigNumber | null = null;
  /*FID=5*/
  public doubletype: CubiqTS.BigNumber | null = null;
  /*FID=6*/
  public doubleObject: CubiqTS.BigNumber | null = null;
  /*FID=7*/
  public enumType: CubiqTS.AccountBookingType;
  /*FID=8*/
  public listObject: Array<CubiqTS.Account> | null = null;
  /*FID=9*/
  public mapObject: Map<string, string> | null = null;
  /*FID=10*/
  public account: CubiqTS.Account | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = TestEntityEncoder.Instance;
    this.setEncodableType(TestEntity.enType);
    //Model
  }

  public toString(): string {
    return (
      "TestEntity[" +
      "id=" +
      this.id +
      "integer=" +
      this.integer +
      "integerObject=" +
      this.integerObject +
      "bigD=" +
      this.bigD +
      "doubletype=" +
      this.doubletype +
      "doubleObject=" +
      this.doubleObject +
      "enumType=" +
      this.enumType +
      "listObject=" +
      this.listObject +
      "mapObject=" +
      this.mapObject +
      "account=" +
      this.account +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
